import axiosInstance from '../axiosInstance';

export interface SponsorSettingsResponse {
  status: boolean;
  message: string;
  data: sponsorSettings;
}

export interface sponsorSettings {
  isUpgradeModalEnabled: boolean;
  isSponsorEmailsEnabled: boolean;
  tenantId?: string;
}

export async function getSponsorSettings(
  tenantId: string
): Promise<SponsorSettingsResponse> {
  const response = await axiosInstance.get(
    '/api/v1/sponsor/get-sponsor-settings',
    {
      headers: {
        'x-tenant-id': tenantId,
      },
    }
  );
  return response.data as SponsorSettingsResponse;
}

export async function updateSponsorSettings(
  params: sponsorSettings
): Promise<SponsorSettingsResponse> {
  const { tenantId, ...payload } = params;
  const response = await axiosInstance.post(
    '/api/v1/sponsor/update-sponsor-settings',
    { ...payload },
    {
      headers: {
        'x-tenant-id': tenantId,
      },
    }
  );
  return response.data as SponsorSettingsResponse;
}
